var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadsActiveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_724_1102",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_724_1102)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#5367FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_724_1102",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_724_1102",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAACxAAAAsQHGLUmNAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAgVJREFUSIml1c+LjlEUB/DPO8bkXaiRZMNCxDvGrxLSjI0Vi2Ehm5E0FBakbCTKf2BB9rKztCAbCdmM/CqDDGkoRE0GaUzzw+Lep7meeZ/3Hc+cut3nfr/d73nuOeeeWzE724JjWIsxPMAVfJnl/oZ2AROYyo3v2DlX8UOJ4FXsw1E8j9gIVpQVbxNCMIUTOa6Ke5G7VtbBrijwooDfGvnfmF8k0tLAQWec7xbwj/BTOM3KMg4ybqyAn8Jo/J5XxsH7OG8q4JdjiVBhQw10Cm0ZJoUYL6rDHxdO8biMeGYPo8i5HF7By8idaiRQGLtoQ0KcP6A/wRdidcQums5FKevE9jr4QaGC5mQbsL8B34uOsuI92JasW7BRqJ7MWrEH6/5HuIbdWJpgC3BfSOokzidcGxbHPbVm4kdMd843aI94n3876UTyA+0YTPDDjRxkpZeNvoifNLNdZ+0h73wgFczf5G+59dc4X8enBL+Bd0321LX1Qq//hUvChSJ0y27hVevFmoSr4HLc80wu4ekJunEWN4WnsQObhQdmWHgmR7EDr4W4d+GAcFdW4U7U6Mr/+V7TyR3HbTwVSjCN70f8SdbDUWwMt4QKy5Ldkzp4ZWYSz8TT5PH8OI0ndfCBLETVGNO8fRb6TTPrwNs6eA3V1nisfuFWpvZDCNNIEweDwkXLt+1xTP4F/rqYnNJTDTEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsActiveIcon);
export default __webpack_public_path__ + "static/media/leadsActiveIcon.814c03698b5654987bf52e2b401ca3e9.svg";
export { ForwardRef as ReactComponent };